import { Divider, Drawer, Grid, Typography } from '@material-ui/core';
import { CadastroCdcaApiRequest } from 'common/genericTypes';
import UploadDocs, { Attachment } from 'components/uploadDocs';
import { Button, DatePicker, MdSpace, SmSpace } from 'm2m.components';
import { Dispatch, SetStateAction, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { dataAditamento } from 'store/modules/cdca/aditamento';
import CdcaParser from 'utils/parsers/cdcaParser';
import { addAlert } from 'store/modules/snackBar';

export function FormularioDrawerAditamento({
  open,
  setOpen,
  handleSubmit,
  codigo,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleSubmit: () => void;
  codigo: string;
}) {
  const dispatch = useDispatch();
  const [documento, setDocumento] = useState<File | undefined>();

  const caracteristicas = useSelector((state: RootState) => state.cdcaCadastro.caracteristicas);
  const criteriosRemuneracao = useSelector((state: RootState) => state.cdcaCadastro.criteriosRemuneracao);
  const eventos = useSelector((state: RootState) => state.cdcaCadastro.eventos);
  const uploadDocumentos = useSelector((state: RootState) => state.cdcaCadastro.uploadDocumentos);
  const emissor = useSelector((state: RootState) => state.cdcaCadastro.emissor);
  const cdcaId = useSelector((state: RootState) => state.cdcaCadastro.caracteristicas.id);
  const dateAditamento = useSelector((state: RootState) => state.cdcaCadastro.dataAditamento);

  const cdcaApi = useSelector((state: RootState) => state.cdcaApi);

  const handleUpdateFileToStore = (attachments: Attachment[]): void => {
    const newAttachment = attachments?.[0].file;
    setDocumento(newAttachment);
  };

  const submitPutCdcaAditamento = async (
    cdcaId: string,
    cdca: CadastroCdcaApiRequest,
    file: File
  ): Promise<string> => {
    try {
      if (typeof dateAditamento !== 'undefined') {
        return await cdcaApi.putCdcaAditamento(
          dispatch,
          cdcaId,
          cdca,
          dateAditamento,
          file,
          true
        );
      } else throw 'Falta informações a serem aditadas';
    } catch (error: any) {
      console.log(error);
      dispatch(addAlert({ message: error, severity: 'error' }));
    }
    return codigo;
  };

  const handleAditamentoSubmit = async (): Promise<string | (() => void)> => {
    try {
      const cdca: CadastroCdcaApiRequest = CdcaParser.stateToCadastroCdcaApiRequest(
        caracteristicas,
        criteriosRemuneracao,
        eventos,
        uploadDocumentos,
        emissor
      );
      if (!cdcaId) throw 'Erro ao aditar.';
      let cdcaResponse;

      if (documento) {
        cdcaResponse = await submitPutCdcaAditamento(cdcaId, cdca, documento);
        if (!cdcaResponse || cdcaResponse.length === 0) throw 'Erro ao aditar';
        
        dispatch(addAlert({ message: cdcaResponse, severity: 'success' }));
        handleSubmit();
      }
      if (!cdcaResponse) throw 'Erro ao aditar';

      return cdcaResponse;
    } catch (error: any) {
      dispatch(addAlert({ message: error.message, severity: 'error' }));

      throw error;
    }
  };

  const handleUpdateDataAditamento = (input: string | undefined): void => {
    dispatch(dataAditamento(input));
  };
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{ style: { padding: '40px', maxWidth: 460 } }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h3">{'Aditamento'}</Typography>
          <SmSpace />
          <Divider variant="fullWidth" />
          <MdSpace />
          <Typography variant="body2">{`Tem certeza que deseja solicitar aditamento do instrumento ${codigo}?`}</Typography>
          <SmSpace />
          <DatePicker
            value={undefined}
            label="Data do aditamento"
            onChange={(value) => handleUpdateDataAditamento(value?.format())}
          />
          <SmSpace />
          <UploadDocs
            aditamento={true}
            multipleFiles={false}
            inputAttachments={[]}
            onChange={handleUpdateFileToStore}
          />
          <MdSpace />
          <Button
            onClick={handleAditamentoSubmit}
            disabled={typeof documento === 'undefined'}
            variant="contained"
            color="primary"
            fullWidth
          >
            {'Solicitar Aditamento'}
          </Button>
          <SmSpace />
          <Button onClick={() => setOpen(false)} variant="contained" color="error" fullWidth>
            {'Cancelar'}
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  );
}
